<template>
  <v-toolbar flat dense :color="options.bgColor" style="margin: 0 6px 6px 2px;">
    <v-btn
      v-if="isNestedEntity"
      icon
      data-test="closeNestedCard"
      max-height="36"
      max-width="36"
      :class="{ shadow: options.shadow }"
      :color="options.textColor"
      @click.stop="$emit('close-nested-card')"
    >
      <v-icon :color="options.textColor">mdi-arrow-left</v-icon>
    </v-btn>
    <v-btn
      data-test="favouriteActionCard"
      v-if="isObject && !isNestedEntity"
      icon
      :class="{ shadow: options.shadow }"
      :color="options.textColor"
      @click.stop="$emit('favourite-action', favourite)"
    >
      <v-icon :color="options.textColor" v-if="favourite">mdi-star</v-icon>
      <v-icon :color="options.textColor" v-else>mdi-star-outline</v-icon>
    </v-btn>

    <v-toolbar-title
      v-if="options.showTitle"
      class="primary--text font-weight-medium"
    >
      {{ title }}
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <app-entity-toolbar-menu
      v-on="$listeners"
      :items="contextMenu"
      :color="options.textColor"
      :activatorClass="{ shadow: options.shadow }"
    />

    <v-btn
      data-test="closeActionCard"
      max-height="36"
      max-width="36"
      icon
      @click="$emit('close')"
      :color="options.textColor"
      :class="{ shadow: options.shadow }"
      fab
    >
      <v-icon :color="options.textColor">mdi-close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
import AppEntityToolbarMenu from './EntityToolbarMenu';

export default {
  name: 'AppEntityToolbar',
  components: {
    AppEntityToolbarMenu
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    currentTab: {
      type: Number,
      default: 0
    },
    isNestedEntity: {
      type: Boolean,
      default: false
    },
    favourite: {
      type: Boolean,
      default: false
    },
    transparent: {
      type: Boolean,
      default: true
    },
    tabs: {
      type: Array,
      default: () => []
    },
    entity: {
      type: Object,
      default: () => ({})
    },
    contextMenu: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isObject() {
      return ['media', 'device', 'dataset', 'application'].includes(
        this.entity?.type
      );
    },
    options() {
      return this.transparent
        ? {
            bgColor: 'transparent',
            textColor: '#686868',
            showTitle: false,
            shadow: true
          }
        : {
            bgColor: undefined,
            textColor: 'primary',
            showTitle: true,
            shadow: false
          };
    }
  }
};
</script>

<style lang="sass" scoped>
.shadow
    background-color: rgba(255, 255, 255, 0.44) !important
    border-color: rgba(255, 255, 255, 0.44) !important
::v-deep
    .v-toolbar__extension
        padding-left: 0 !important
        padding-right: 0 !important
    .v-toolbar__content > .v-btn.v-btn--icon
        margin-left: 4px
        margin-right: 4px
</style>
